"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Client = exports.DEFAULT_GOVERNANCE_PROGRAM_ID = void 0;
const web3_js_1 = require("@solana/web3.js");
const spl_governance_1 = require("@solana/spl-governance");
exports.DEFAULT_GOVERNANCE_PROGRAM_ID = new web3_js_1.PublicKey("GovER5Lthms3bLBqWub97yVrMmEogzX7xNjdXpPPCVZw");
class Client {
    constructor(program, devnet) {
        this.program = program;
        this.devnet = devnet;
    }
    /**
     * Preview what this voter weight plugin does to the max voter's vote weight.
     * This is equivalent to calculateVoterWeight, but it has a default implementation,
     * that just returns the inputMaxVoterWeight, because plugins that set the max voter weight
     * are rarer.
     * @param _realm
     * @param _mint
     * @param inputMaxVoterWeight
     */
    calculateMaxVoterWeight(_realm, _mint, inputMaxVoterWeight) {
        return __awaiter(this, void 0, void 0, function* () {
            return inputMaxVoterWeight;
        });
    }
    getRegistrarAccount(realm, mint) {
        return __awaiter(this, void 0, void 0, function* () {
            const { registrar } = this.getRegistrarPDA(realm, mint);
            const registrarObject = yield this.program.account.registrar.fetchNullable(registrar);
            // previousVoterWeightPluginProgramId should be added to the object automatically by the type inference from IsPluginIdl
            // but Typescript does not seem to be that clever yet
            return registrarObject;
        });
    }
    /**
     * If this plugin uses a persistent voter weight record, get it
     * @param realm
     * @param mint
     * @param walletPk
     */
    getVoterWeightRecord(realm, mint, walletPk) {
        return __awaiter(this, void 0, void 0, function* () {
            const { voterWeightPk } = this.getVoterWeightRecordPDA(realm, mint, walletPk);
            const voterWeightRecordAccount = this.program.account.voterWeightRecord;
            // TODO handle this at the type-level with a better PluginProgramAccounts type.
            if (!voterWeightRecordAccount)
                return null;
            const voterWeightRecord = yield voterWeightRecordAccount.fetchNullable(voterWeightPk);
            return voterWeightRecord;
        });
    }
    getMaxVoterWeightRecord(realm, mint) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const { maxVoterWeightPk } = (_a = this.getMaxVoterWeightRecordPDA(realm, mint)) !== null && _a !== void 0 ? _a : {};
            if (!maxVoterWeightPk)
                return null; // this plugin does not have a max voter weight record
            const maxVoterWeightRecordAccount = this.program.account.maxVoterWeightRecord;
            // TODO handle this at the type-level with a better PluginProgramAccounts type.
            if (!maxVoterWeightRecordAccount)
                return null;
            const maxVoterWeightRecord = yield maxVoterWeightRecordAccount.fetchNullable(maxVoterWeightPk);
            return maxVoterWeightRecord;
        });
    }
    getRegistrarPDA(realm, mint) {
        const [registrar, registrarBump] = web3_js_1.PublicKey.findProgramAddressSync([Buffer.from('registrar'), realm.toBuffer(), mint.toBuffer()], this.program.programId);
        return {
            registrar,
            registrarBump,
        };
    }
    // Should be overridden by the plugin if the plugin has a max voter weight record (most plugins do not)
    // Boilerplate for those plugins:
    // return Client.getMaxVoterWeightRecordPDAForProgram(realm, mint, this.program.programId)
    getMaxVoterWeightRecordPDA(realm, mint) {
        return null;
    }
    getPredecessorVoterWeightRecordPDA(realm, mint, voter, inputRecordCallback) {
        return __awaiter(this, void 0, void 0, function* () {
            // if the previous plugin has a specific way of deriving the input voter weight, use it
            // otherwise derive it the default way.
            if (inputRecordCallback) {
                return inputRecordCallback();
            }
            const inputVoterWeight = yield this.derivePredecessorVoterWeightRecordPDA(realm, mint, voter);
            if (inputVoterWeight)
                return inputVoterWeight.voterWeightPk;
            // no predecessor voter weight record found - pass the token owner record
            return (0, spl_governance_1.getTokenOwnerRecordAddress)(exports.DEFAULT_GOVERNANCE_PROGRAM_ID, realm, mint, voter);
        });
    }
    static deriveVoterWeightRecordPDAForProgram(realm, mint, walletPk, programId) {
        const [voterWeightPk, voterWeightRecordBump,] = web3_js_1.PublicKey.findProgramAddressSync([
            Buffer.from('voter-weight-record'),
            realm.toBuffer(),
            mint.toBuffer(),
            walletPk.toBuffer(),
        ], programId);
        return {
            voterWeightPk,
            voterWeightRecordBump,
        };
    }
    static getMaxVoterWeightRecordPDAForProgram(realm, mint, programId) {
        const [maxVoterWeightPk, maxVoterWeightRecordBump,] = web3_js_1.PublicKey.findProgramAddressSync([
            Buffer.from('max-voter-weight-record'),
            realm.toBuffer(),
            mint.toBuffer(),
        ], programId);
        return {
            maxVoterWeightPk,
            maxVoterWeightRecordBump,
        };
    }
    getVoterWeightRecordPDA(realm, mint, walletPk) {
        return Client.deriveVoterWeightRecordPDAForProgram(realm, mint, walletPk, this.program.programId);
    }
    derivePredecessorVoterWeightRecordPDA(realm, mint, walletPk) {
        return __awaiter(this, void 0, void 0, function* () {
            const predecessorProgramId = yield this.getPredecessorProgramId(realm, mint);
            if (!predecessorProgramId)
                return undefined;
            return Client.deriveVoterWeightRecordPDAForProgram(realm, mint, walletPk, predecessorProgramId);
        });
    }
    /**
     * Returns the PDA of the max voter weight record for the predecessor program.
     * WARNING: This function just derives the PDA, but the max voter weight record itself may not exist.
     * @param realm
     * @param mint
     */
    derivePredecessorMaxVoterWeightRecordPDA(realm, mint) {
        return __awaiter(this, void 0, void 0, function* () {
            const predecessorProgramId = yield this.getPredecessorProgramId(realm, mint);
            if (!predecessorProgramId)
                return undefined;
            return Client.getMaxVoterWeightRecordPDAForProgram(realm, mint, predecessorProgramId);
        });
    }
    getPredecessorProgramId(realm, mint) {
        return __awaiter(this, void 0, void 0, function* () {
            // Get the registrar for the realm
            const registrarObject = yield this.getRegistrarAccount(realm, mint);
            // Find the gatekeeper network from the registrar
            return registrarObject === null || registrarObject === void 0 ? void 0 : registrarObject.previousVoterWeightPluginProgramId;
        });
    }
}
exports.Client = Client;
//# sourceMappingURL=Client.js.map